<div class="sk-lap">
  <div class="sk-fej">
    <img [src]="ikon" alt="">
    <div>
      <h1>{{ sz.aktiv.ugyfelNev || 'Számla és Kassza' }}</h1>
      <p>Számlák kiállítása és a NAV Online Számla adatszolgáltatás{{ sz.aktiv.szerep === 'konyvelo' ? ' – könyvelői nézet, csak olvasás' : '' }}.</p>
    </div>
  </div>
  <div class="sk-ossz" *ngIf="ossz">
    <div><span>{{ sz.aktiv.ev }}. évi számlák</span><b>{{ ossz.db }} db</b></div>
    <div><span>Kiállítva összesen (bruttó)</span><b>{{ szam(ossz.brutto) }} Ft</b></div>
    <div><span>Kifizetetlen</span><b>{{ szam(ossz.nyitott) }} Ft</b></div>
    <div><span>Nyitott díjbekérő</span><b>{{ ossz.dijbekero }} db</b></div>
    <div [class.rossz]="ossz.navHiba"><span>NAV-hiba</span><b>{{ ossz.navHiba }} db</b></div>
  </div>
  <div class="sk-racs">
    <button type="button" class="sk-csempe kesz" *ngFor="let c of csempek" (click)="nyit(c)">
      <ion-icon [name]="c.ikon"></ion-icon>
      <div class="sk-szoveg"><b>{{ c.cim }}</b><span>{{ c.leiras }}</span></div>
    </button>
  </div>
</div>
